/*
--------------------------------------------------------------------------------
Registration module
--------------------------------------------------------------------------------
*/

import "../Styles/details-step.css";

(function ($) {

    "use strict";

    if (typeof ori !== "object") return;

    var self,
        CONTINUE_BUTTON = ".js-checkout-registration",
        NEW_CUSTOMER_TABS_WRAPPER = ".js-new-customer-tabs-wrapper",
        NEW_CUSTOMER_TABS = NEW_CUSTOMER_TABS_WRAPPER + " .tab",
        NEW_CUSTOMER_TABS_HEADINGS = NEW_CUSTOMER_TABS_WRAPPER + " .tab-links .js-tab-item",
        NEW_CUSTOMER_TAB_HEADING = "#new-customer-tab-heading",
        REGISTRATION_TAB = "#new-customer-tab",
        DISABLED = "disabled",
        BIRTHDATE_INPUT = ".js-birthdate input",
        BIRTHDATE_DEFAULT_YEAR = "data-default-year",
        DISABLED_CLASS = "k-state-disabled",
        LOGIN_PLACEHOLDER_SELECTOR = ".js-login-placeholder",
        TELEPHONE_VERIFICATION_DIALOG = "#telephoneVerificationDialog",
        SPONSOR_NUMBER_INPUT_NAME = "SponsorNumber",
        SPONSOR_NAME_INPUT = "#sponsor-name",
        CLICK_EVENT = "click",
        SEL_CUSTOMER_REGISTRATION = ".js-customer-registration",
        SEL_CUSTOMER_REGISTRATION_FORM = ".js-customer-registration-form",
        SEL_CREATE_ACCOUNT_SECTION = ".js-create-account-section",
        SEL_APPROVALS_SECTION = ".js-approvals-section-wrapper",
        SEL_APPROVALS_TOGGLE = ".js-approvals-section-toggle",
        SEL_APPROVALS_TOGGLE_ICON = ".js-approvals-toggle-icon",
        SEL_ANONYMOUS_REGISTRATION_SECTION = ".js-anonymous-registration-section",
        isNewCustomerTabShown = true,
        registrationForm,
        $registrationWrapper,
        $passwordSection,
        $continueButton,
        $loginPlaceholder,
        registrationFormValidator,
        sponsorNumberInput,
        sponsorName,
        anonymousCheckout = null;


    ori.shopping.addModule("registration", {
        init: function (options) {
            // set options if provided
            self.setOptions(options);
            
            $registrationWrapper = $(SEL_CUSTOMER_REGISTRATION);
            
            initTabs();
            initializeForm();


            self.registerEventHandlers();
        },

        registerEventHandlers: function () {
            registerContinueClickHandler();
        },

        doCheckout: function () {
            ori.shopping.wizard.navigateNext();
            $continueButton = $(CONTINUE_BUTTON);
        },

        onRemoteValidate: function (event) {
            if (event.inputName === SPONSOR_NUMBER_INPUT_NAME) {
                var $sponsorName = $(sponsorName);
                if (sponsorName === null || sponsorName === undefined) {
                    return;
                }

                $sponsorName.text(event.response.sponsorName);
                $sponsorName.parent().toggleClass("hidden", !event.valid || $(sponsorNumberInput).val() === "");
            }
        },

        toggleAnonymousCheckout: toggleAnonymousCheckout
    });

    function registerContinueClickHandler() {
        $(document).on(self.eventString(CLICK_EVENT), CONTINUE_BUTTON, function (e) {
            // Handle the click on checkout button in the popup dialog
            e.preventDefault();
            if (isNewCustomerTabShown) {
                registrationForm.submit();
            }
        });
    }

    function openTelephoneVerificationDialog() {
        var $dialog = $(TELEPHONE_VERIFICATION_DIALOG).data("kendoWindow");
        $dialog
            .content("<div class=\"k-loading-image\"></div>")
            .refresh({ url: self.options.url.getTelephoneVerificationContent })
            .open();
    }

    function setDefaultBirthdateYear($form) {
        var birthDateInput = $(BIRTHDATE_INPUT, $form);
        var defaultYear = birthDateInput.attr(BIRTHDATE_DEFAULT_YEAR);

        if (defaultYear && $.isNumeric(defaultYear)) {
            var birthDateControl = birthDateInput.data("kendoDropDownDatePicker");
            if (birthDateControl.value()) {
                return;
            }

            birthDateControl.year.value(defaultYear);
        }
    }

    function togglePasswordValidation() {
        var $passwordInputs = $passwordSection.find(":input");
        if ($passwordInputs) {
            togglePasswordInputsValidation($passwordInputs, false);
            $passwordInputs.each(function () {
                var $input = $(this);
                $input.on("keyup", function () {
                    var validate = !isPasswordInputEmpty();
                    togglePasswordInputsValidation($passwordInputs, validate);
                    if (validate) {
                        registrationFormValidator.validateInput($input);
                    }
                });
            });
        }
    }

    function togglePasswordInputsValidation(inputs, validate) {
        inputs.each(function () {
            var $input = $(this);
            if ($input.data("val") !== null) {
                $input.data("val", validate);
            }
            if (!validate) {
                $input.closest("span.k-password").removeClass("error");
                $input.siblings("span.k-invalid-msg").hide();
            }
        });
    }

    function initializeForm() {
        var formElement = document.querySelector(SEL_CUSTOMER_REGISTRATION_FORM);
        if (!formElement) {
            return;
        }

        registrationForm = ori.formFactory.create(formElement, {
            callbackAlways: onSubmitAlways,
            callbackBefore: onBeforeSubmit,
            callbackOnSuccess: onSubmitSuccess,
            callbackError: onSubmitError,
            isValidatorUsed: true,
            trimFields: true
        });

        registrationFormValidator = registrationForm.validator;

        var $accountRegistrationSection = $(".js-account-registration-section");
        if ($accountRegistrationSection.length) {
            $passwordSection = $accountRegistrationSection.find(".js-password-section");
            var $passwordInputs = $passwordSection.find(":input");

            // If anonymous section is rendered, then the validation of password is toggled by checkbox state in that section.
            var $anonymousSection = $(SEL_ANONYMOUS_REGISTRATION_SECTION);

            if (self.options.isEndCustomerRegistrationRequired || $anonymousSection.length) {
                togglePasswordInputsValidation($passwordInputs, true);
            } else {
                togglePasswordValidation();
            }
        }

        initApprovalsSection();
        setDefaultBirthdateYear($(registrationForm.context));

        sponsorName = registrationForm.findElement(SPONSOR_NAME_INPUT);
        sponsorNumberInput = registrationForm.findElement("#" + SPONSOR_NUMBER_INPUT_NAME);

        ori.documentComponentFactory.createAll(formElement);
    }

    function onSubmitAlways() {
        togglePasswordInputsDisabling(false);
    }

    function onBeforeSubmit() {
        var isPasswordEmpty = isPasswordInputEmpty();
        // To avoid server validation (sending null model) if disabled
        togglePasswordInputsDisabling(isPasswordEmpty);
        return true;
    }

    function onSubmitSuccess(_, response) {
        if (response.result.Success) {
            // If the form has been successfuly processed propagate context changes to all modules and call the callback function passed from other module
            ori.shopping.wizard.updateShoppingContext(response.result.Context, ori.shopping.wizard.shoppingBagPageId);

            if (response.result.RequiresPhoneValidation) {
                openTelephoneVerificationDialog();
            }
            else {
                ori.shopping.wizard.navigateNext();
            }
        } else {
            $registrationWrapper.html(response.result);
            initializeForm(); // Need to re-initialize because the form html has been updated (selectors needs to be reinitialized also)
            $registrationWrapper.trigger("DOMRefresh");
        }
    }

    function onSubmitError() {
        self.error("register call failed...");
    }

    function initTabs() {
        ori.tabs.init(NEW_CUSTOMER_TABS, NEW_CUSTOMER_TABS_HEADINGS);
        
        $loginPlaceholder = $(LOGIN_PLACEHOLDER_SELECTOR);
        var $detailsPage = $(".js-details-page");
        $detailsPage.on(ori.tabs.TAB_CHANGE_EVENT, NEW_CUSTOMER_TABS_WRAPPER, function () {
            isNewCustomerTabShown = $detailsPage.find(NEW_CUSTOMER_TAB_HEADING).hasClass("active");
            toggleRegistrationValidation();
            $continueButton.toggleClass(DISABLED_CLASS, !isNewCustomerTabShown);
            if (!isNewCustomerTabShown) {
                loadLoginView();
            }
        });
    }

    function toggleRegistrationValidation() {
        var validate = isNewCustomerTabShown,
            $formInputs = $(registrationForm.context).find("input");

        $formInputs.each(function () {
            var $currentInput = $(this);
            if ($currentInput.data("val") !== null) {
                $currentInput.data("val", validate);
            }
        });
    }

    function loadLoginView() {
        var decodedLoginUrl = decodeURIComponent(self.options.url.checkoutLogin);
        ori.spinner.applyOverlayTo($loginPlaceholder);
        $.get(decodedLoginUrl, function (result) {
            $loginPlaceholder.html(result);
        }).always(function () {
            ori.spinner.removeOverlayFrom($loginPlaceholder);
        });
    }

    function isPasswordInputEmpty() {
        var $passwordInputs = $passwordSection.find(":input");
        var areEmpty = true;
        if ($passwordInputs) {
            $passwordInputs.each(function () {
                if ($(this).val()) {
                    areEmpty = false;
                    return false;
                }
                return false;
            });
        }
        return areEmpty;
    }

    function togglePasswordInputsDisabling(disable) {
        var $passwordInputs = $passwordSection.find(":input");
        if ($passwordInputs) {
            $passwordInputs.each(function () {
                $(this).prop(DISABLED, disable);
            });
        }
    }

    function initApprovalsSection() {
        var $toggle = $(SEL_APPROVALS_TOGGLE);
        var $toggleIcon = $(SEL_APPROVALS_TOGGLE_ICON);
        var $sectionBlock = $(SEL_APPROVALS_SECTION);

        // The toggle functionality may be disabled via backoffice configuration.
        if (!$toggle.length || !$toggleIcon.length || !$sectionBlock.length) {
            return;
        }

        $toggle.on("click", function () {
            if ($sectionBlock.is(":visible")) {
                $sectionBlock.slideUp();
            } else {
                $sectionBlock.slideDown();
            }

            $toggleIcon
                .toggleClass("v-icon-arrow-up-thin")
                .toggleClass("v-icon-arrow-down-thin");
        });

    }

    function toggleAnonymousCheckout() {
        if (anonymousCheckout === null) { // Init (on first click)
            anonymousCheckout = {
                isOverlayVisible: false,
                $section: $(SEL_CREATE_ACCOUNT_SECTION),
                $overlay: $(`<div class="ui-disabled-overlay" />`)
            };

            if (anonymousCheckout.$section.length === 0) {
                throw new Error(`Create account section not found.`);
            }

            anonymousCheckout.$overlay.appendTo(anonymousCheckout.$section).hide();
        }

        var $passwordInputs = $passwordSection.find(":input");

        if (!anonymousCheckout.isOverlayVisible) { // Enabling anonymous mode (show overlay)
            anonymousCheckout.$overlay
                .show()
                .css({ opacity: 0 })
                .animate({ opacity: 0.8 }, {
                    duration: "slow",
                    always: function () {
                        // reset password inputs
                        togglePasswordInputsValidation($passwordInputs, false);
                        $passwordInputs.val("");
                    }
                });
        } else { // Disabling anonymous mode (hide overlay)
            anonymousCheckout.$overlay
                .css({ opacity: 0.8 })
                .animate({ opacity: 0 }, {
                    duration: "slow",
                    always: function () {
                        anonymousCheckout.$overlay.hide();
                        togglePasswordInputsValidation($passwordInputs, true);
                    }
                });
        }

        anonymousCheckout.isOverlayVisible = !anonymousCheckout.isOverlayVisible;
    }

    self = ori.shopping.registration;

})(jQuery);
